import React, {PureComponent} from "react"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import id from "@irati/utils/id"
import withBranding, {WithBranding} from "@irati/brand/withBranding"

import UpdateBrand from "../../../components/Settings/Brand"
import SuccessWithBackLink from "../../../components/SuccessWithBackLink"
import {SETTINGS_CUSTOMISE_BRAND} from "../../../routes/routeConfig"

interface Props extends InjectIntl, WithBranding {}

interface State {
  saved: boolean
}

class CompanyBrand extends PureComponent<Props, State> {
  state = {
    saved: false
  }

  onBrandUpdated = () => {
    this.setState({saved: true})
    setTimeout(() => {
      this.setState({saved: false})
    }, 2000)
  }

  render() {
    const {saved} = this.state
    const idNamespace = id("company-brand", this.props)
    const {formatMessage} = this.props

    return (
      <div id={idNamespace}>
        <>
          {saved ?
            <SuccessWithBackLink
              id={idNamespace}
              message={formatMessage({id: "admin.containers.companyBrand.fullModal.success.message"})}
              backLink={SETTINGS_CUSTOMISE_BRAND} />
            :
            <UpdateBrand
              id={idNamespace}
              onBrandUpdated={this.onBrandUpdated}
              imageLink={this.props.branding.businessLogoUrl} />
          }
        </>
      </div>
    )
  }
}

export default withBranding(injectIntl(CompanyBrand))
